export enum LS_KEYS {
    tmpPasswordEmail = 'tmpPasswordEmail',
    showTmpPasswordContactUs = 'showTmpPasswordContactUs',
    tmpPasswordResendTimer = 'tmpPasswordResendTimer',
    tmpPasswordIncorrectCodeAttempts = 'tmpPasswordIncorrectCodeAttempts',
}
